let jQuery = require('jquery');
let cytoscape = require('cytoscape');

export function AddGraphMenus() {
    if ( !cytoscape ) {
        return;
    }
    let cy;
    let defaults = {
        menuItems: [],
        menuItemClasses: [],
        contextMenuClasses: []
    };
    let options;
    let graphMenu;
    let menuItemClass = 'vca-graph-menu-item';
    let menuDividerClass = 'vca-graph-menu-divider';
    let eventCyTapStart;
    let eventCyMouseLeave;
    let active = false;

    function extend(oDefaults, oOptions) {
        let obj = {};

        for (let i in oDefaults) {
            if (oDefaults.hasOwnProperty(i)) {
                obj[i] = oDefaults[i];
            }
        }

        for (let i in oOptions) {
            if (oOptions.hasOwnProperty(i)) {
                obj[i] = oOptions[i];
            }
        }

        return obj;
    };

    function preventDefaultContextTap() {
        jQuery('#vca-graph-menu').contextmenu( function() {
            return false;
        });
    }

    function getMenuItemClassStr(classes, hasTrailingDivider) {
        let str = getClassStr(classes);
        str += ' ' + menuItemClass;
        if (hasTrailingDivider) {
            str += ' ' + menuDividerClass;
        }
        return str;
    }

    function getClassStr(classes) {
        let str = '';
        if (classes.length) {
            for (let i = 0; i < classes.length; i++) {
                let className = classes[i];
                str += className;
                if (i !== classes.length - 1) {
                    str += ' ';
                }
            }
        }
        return str;
    }

    function displayComponent(component) {
        component.css('display', 'block');
    }

    function hideComponent(component) {
        component.css('display', 'none');
    }

    function hideMenuItemComponents() {
        graphMenu.children().css('display', 'none');
    }

    function bindOnClickFunction(component, onClickFcn) {
        let callOnClickFcn;
        component.on('click', callOnClickFcn = function() {
            onClickFcn(cy.scratch('currentGraphEvent'));
        });
        component.data('call-on-click-function', callOnClickFcn);
    }

    function bindGraphTap(component, selector, coreAsWell) {
        let graphFunction, graphCoreFunction;

        if (coreAsWell) {
            cy.on('tap', graphCoreFunction = function(event) {
                if ( event.cyTarget !== cy ) {
                    return;
                }
                cy.scratch('currentGraphEvent', event);
                adjustGraphMenu(event);
                displayComponent(component);
            });
        }

        if (selector) {
            cy.on('tap', selector, graphFunction = function(event) {
                cy.scratch('currentGraphEvent', event);
                adjustGraphMenu(event);
                displayComponent(component);
            });
        }

        component.data('graph-menu-function', graphFunction);
        component.data('graph-menu-core-function', graphCoreFunction);
    }

    function bindEvents() {
        cy.on('tapstart', eventCyTapStart = function(){
            hideComponent(graphMenu);
            cy.removeScratch('graphMenuPosition');
            cy.removeScratch('currentGraphEvent');
        });
        graphMenu.on('mouseleave', eventCyMouseLeave = function(){
            hideComponent(graphMenu);
            cy.removeScratch('graphMenuPosition');
            cy.removeScratch('currentGraphEvent');
        });
    }

    function performBindings(component, onClickFcn, selector, coreAsWell) {
        bindOnClickFunction(component, onClickFcn);
        bindGraphTap(component, selector, coreAsWell);
    }

    function adjustGraphMenu(event) {
        let currentGraphMenuPosition = cy.scratch('graphMenuPosition');

        if ( currentGraphMenuPosition !== event.cyPosition ) {
            hideMenuItemComponents();
            cy.scratch('graphMenuPosition', event.cyPosition);
            let containerPos = jQuery(cy.container()).position();
            let left = containerPos.left + event.cyRenderedPosition.x;
            let top = containerPos.top + event.cyRenderedPosition.y;
            displayComponent(graphMenu);
            graphMenu.css('left', left);
            graphMenu.css('top', top);
        }
    }

    function createAndAppendMenuItemComponents(menuItems) {
        for (let i = 0; i < menuItems.length; i++) {
            createAndAppendMenuItemComponent(menuItems[i]);
        }
    }

    function createAndAppendMenuItemComponent(menuItem) {
        let menuItemComponent = createMenuItemComponent(menuItem);
        appendComponentToGraphMenu(menuItemComponent);
        performBindings(menuItemComponent, menuItem.onClickFunction,
            menuItem.selector, menuItem.coreAsWell);
    }

    function createAndInsertMenuItemComponentBeforeExistingComponent(menuItem, existingId) {
        let menuItemComponent = createMenuItemComponent(menuItem);
        insertComponentBeforeExistingItem(menuItemComponent, existingId);
        performBindings(menuItemComponent, menuItem.onClickFunction,
            menuItem.selector, menuItem.coreAsWell);
    }

    function createAndAppendGraphMenuComponent() {
        let classes = getClassStr(options.contextMenuClasses);
        graphMenu = jQuery('<div id="vca-graph-menu" class=' + classes + '></div>');
        jQuery('app').append(graphMenu);
        return graphMenu;
    }

    function createMenuItemComponent(item) {
        let classStr = getMenuItemClassStr(options.menuItemClasses, item.hasTrailingDivider);
        let itemStr = '<button id="' + item.id + '" title="' +
            item.title + '" class="' + classStr + '"';
        if (item.disabled) {
            itemStr += ' disabled';
        }
        itemStr += '></button>';
        let menuItemComponent = jQuery(itemStr);
        menuItemComponent.data('selector', item.selector);
        menuItemComponent.data('on-click-function', item.onClickFunction);
        return menuItemComponent;
    }

    function appendComponentToGraphMenu(component) {
        graphMenu.append(component);
        bindMenuItemClickFunction(component);
    }

    function insertComponentBeforeExistingItem(component, existingId) {
        let existingItem = jQuery('#' + existingId);
        component.insertBefore(existingItem);
    }

    function destroyCxtMenu() {
        if (!active) {
            return;
        }
        removeAndUnbindMenuItems();
        cy.off('tapstart', eventCyTapStart);
        cy.off('mouseleave', eventCyMouseLeave);
        graphMenu.remove();
        graphMenu = undefined;
        active = false;
    }

    function removeAndUnbindMenuItems() {
        let children = graphMenu.children();
        jQuery(children).each(function() {
            removeAndUnbindMenuItem(jQuery(this));
        });
    }

    function removeAndUnbindMenuItem(id) {
        let component = typeof id === 'string' ? jQuery('#' + id) : id;
        let graphFunction = component.data('graph-menu-function');
        let selector = component.data('selector');
        let callOnClickFcn = component.data('call-on-click-function');
        let graphCoreFunction = component.data('graph-menu-core-function');
        if (graphFunction) {
            cy.off('tap', selector, graphFunction);
        }
        if (graphCoreFunction) {
            cy.off('tap', graphCoreFunction);
        }
        if (callOnClickFcn) {
            component.off('click', callOnClickFcn);
        }
        component.remove();
    }

    function moveBeforeOtherMenuItemComponent(id, existingId) {
        if ( id === existingId ) {
            return;
        }
        let component = jQuery('#' + id).detach();
        let existingComponent = jQuery('#' + existingId);
        component.insertBefore(existingComponent);
    }

    function bindMenuItemClickFunction(component) {
        component.click( function() {
            hideComponent(graphMenu);
            cy.removeScratch('graphMenuPosition');
        });
    }

    function disableComponent(id) {
        jQuery('#' + id).attr('disabled', true);
    }

    function enableComponent(id) {
        jQuery('#' + id).attr('disabled', false);
    }

    function setTrailingDivider(id, status) {
        let component = jQuery('#' + id);
        if (status) {
            component.addClass(menuDividerClass);
        } else {
            component.removeClass(menuDividerClass);
        }
    }

    function getGraphMenuInstance(cyInstance) {
        let instance = {
            isActive: function() {
                return active;
            },
            appendMenuItem: function(item) {
                createAndAppendMenuItemComponent(item);
                return cyInstance;
            },
            appendMenuItems: function(items) {
                createAndAppendMenuItemComponents(items);
                return cyInstance;
            },
            removeMenuItem: function(id) {
                removeAndUnbindMenuItem(id);
                return cyInstance;
            },
            setTrailingDivider: function(id, status) {
                setTrailingDivider(id, status);
                return cyInstance;
            },
            insertBeforeMenuItem: function(item, existingId) {
                createAndInsertMenuItemComponentBeforeExistingComponent(item, existingId);
                return cyInstance;
            },
            moveBeforeOtherMenuItem: function(id, existingId) {
                moveBeforeOtherMenuItemComponent(id, existingId);
                return cyInstance;
            },
            disableMenuItem: function(itemID) {
                disableComponent(itemID);
                return cyInstance;
            },
            enableMenuItem: function(itemID) {
                enableComponent(itemID);
                return cyInstance;
            },
            destroy: function() {
                destroyCxtMenu();
                return cyInstance;
            }
        };
        return instance;
    }

    cytoscape('core', 'GraphMenus', function (opts) {
        cy = this;
        if ( opts !== 'get' ) {
            options = extend(defaults, opts);
            if (active) {
                destroyCxtMenu();
            }
            active = true;
            graphMenu = createAndAppendGraphMenuComponent();
            let menuItems = options.menuItems;
            createAndAppendMenuItemComponents(menuItems);
            bindEvents();
            preventDefaultContextTap();
        }
        return getGraphMenuInstance(this);
    });
};



// WEBPACK FOOTER //
// ./src/common/vca-graph/vca-graph-menus.cytoscape.ts